import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DateInput } from "@/components/DateInput";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Lisbon" });

export function ImpicSubmetido({ p, onClose, onConfirm }) {
  const [date, setDate] = useState(today());
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-md" data-testid="impic-submit-dialog">
        <DialogHeader>
          <DialogTitle>Marcar como submetido</DialogTitle>
          <DialogDescription>Confirme que submeteu a comunicação do {p.label} no portal do IMPIC.</DialogDescription>
        </DialogHeader>
        <label className="text-sm font-medium">Data da submissão</label>
        <DateInput value={date} max={today()} onChange={(e) => setDate(e.target.value)} data-testid="impic-submit-date" />
        <DialogFooter>
          <button onClick={onClose} className="px-4 py-2.5 rounded-lg text-sm border border-slate-300" data-testid="impic-submit-cancel">Cancelar</button>
          <button disabled={!date} onClick={() => onConfirm(date)} className="px-4 py-2.5 rounded-lg text-sm font-semibold navy-bg text-white disabled:opacity-40" data-testid="impic-submit-confirm">Confirmar</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
